import { assignRep, getTags, getTicketHistory, getWaitingTickets, sendResponseTicket } from "../../api/ticket";

const ticket = {
    namespaced: true,
    state: {
        waitingTickets: {
            tickets: [],
            totalPages: 10,
            currentPage: 1,
        },
        ticketHistory: {
            tickets: [],
            totalPages: 0,
            currentPage: 1,
            count: 0,
        },
        topics: [],
    },
    getters: {
        getWaitingTickets(state) {
            return state.waitingTickets.tickets;
        },
        getTicketHistory(state) {
            return state.ticketHistory.tickets;
        },
        getTopics(state) {
            return state.topics;
        },
    },
    mutations: {
        SET_WAITING_TICKETS: (state, payload) => {
            state.waitingTickets = payload.data;
        },
        SET_TICKET_HISTORY: (state, payload) => {
            if (!_.isEqual(state.ticketHistory, payload.data)) {
                state.ticketHistory = payload.data;
            }
        },
        SET_REPRESENTATIVE: (state, payload) => {
            let ticketIndex = state.waitingTickets.tickets.findIndex((x) => x._id === payload.data._id);
            state.waitingTickets.tickets[ticketIndex] = payload.data;
        },
        SEND_TICKET_DONE: (state, payload) => {
            let ticketId = payload.data._id;
            state.waitingTickets.tickets = state.waitingTickets.tickets.filter((x) => x._id !== ticketId);
        },
        SET_TOPIC: (state, payload) => {
            state.topics = payload.data;
        },
    },
    actions: {
        async fetchWaitingTickets({ commit }, queries) {
            const tickets = await getWaitingTickets(queries);
            commit("SET_WAITING_TICKETS", tickets);
            return tickets;
        },
        async assignRepresentative({ commit }, data) {
            return commit("SET_REPRESENTATIVE", await assignRep(data));
        },
        async sendTicketResponse({ commit }, data) {
            console.log("Store sendTicketResponse çağrıldı, data:", data);
            console.log("Store resolved değeri:", data.resolved);
            commit(
                "SEND_TICKET_DONE",
                await sendResponseTicket(data._id, data.repId, data.customerEmail, data.response, data.senderMailId, data.resolved),
            );
        },
        async fetchTicketHistory({ commit }, data) {
            commit(
                "SET_TICKET_HISTORY",
                await getTicketHistory(
                    data.dateBegin,
                    data.dateEnd,
                    data.pageCount,
                    data.perPage,
                    data.query,
                    data.assignedUser,
                    data.rate,
                    data.status
                )
            );
        },
        async fetchTopics({ commit }) {
            commit("SET_TOPIC", await getTags());
        },
    },
};

export default ticket;
